import { cubicEaseOut, transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import { contentStyles, h1 } from '@helpers/typography';
import UmbracoFormStyles from '@stories/Components/Forms/UmbracoForm/UmbracoForm.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  padding: var(--sectionSpacing) 0;

  ${SectionWrapperStyles.Inner} {
    ${baseGrid};

    gap: 0px;
    position: relative;

    @media ${from(Device.TabletLarge)} {
      min-height: calc(90vh - var(--headerHeight, 0px));
    }
  }
`;
const ContentWrapper = styled.div `
  grid-column: span 12;
  padding: ${fluid(30, 82)} ${fluid(20, 96)};
  background-color: ${brand.green};
  color: ${brand.white};

  @media ${from(Device.TabletLarge)} {
    grid-column: span 5;
  }
`;
const ContentInner = styled.div `
  position: sticky;
  top: 16px;
`;
const Title = styled.h2 `
  ${h1};
`;
const Content = styled.div `
  ${contentStyles};

  p {
    font-weight: 300;
    line-height: 1.5;
  }
`;
const FormWrapper = styled.div `
  grid-column: span 12;
  padding: ${fluid(20, 56)} ${fluid(20, 40)};
  background-color: ${brand.beige};

  ${UmbracoFormStyles.Container} {
    &::before {
      ${transition('background-size', 1.5)};

      content: '';
      position: absolute;
      z-index: 1;
      top: 0;
      left: var(--sitePadding);
      height: 100%;
      width: calc(100% - (var(--sitePadding) * 2));
      background: transparent;
      background-image: linear-gradient(to right, ${brand.green}, ${brand.green});
      background-repeat: no-repeat;
      background-size: 0% 100%;
      pointer-events: none;
    }

    &:has(${UmbracoFormStyles.ConfirmationMessage})::before {
      background-size: 100% 100%;
    }
  }

  ${UmbracoFormStyles.Container}::before {
  }

  ${UmbracoFormStyles.ConfirmationMessage} {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: ${brand.white};
    opacity: 0;
    transform: translate(-50%, calc(-50% + 26px));
    animation: fadeIn 350ms ${cubicEaseOut} 1.5s forwards;
    width: calc(100% - (var(--sitePadding) * 2));

    > svg {
      border: ${fluid(2, 4)} solid ${brand.white};
      border-radius: 50%;
    }

    p {
      font-weight: 300;
      line-height: 1.5;
      max-width: 42ch;
      text-wrap: balance;
    }
  }

  @keyframes fadeIn {
    20% {
      opacity: 0;
      transform: translate(-50%, calc(-50% + 26px));
    }

    100% {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }

  @media ${from(Device.TabletLarge)} {
    ${scrollbars};

    grid-column: span 7;
    overflow: auto;

    ${UmbracoFormStyles.Fieldset} {
      display: grid;
      column-gap: ${fluid(30, 40)};
      grid-template-columns: repeat(2, 1fr);
    }

    ${UmbracoFormStyles.Field}[data-textarea] {
      grid-column: span 2;
    }

    ${UmbracoFormStyles.Field}[data-consent-field="true"] {
      grid-column: span 2;
      margin: 0 0 ${fluid(20, 40)};
    }

    ${UmbracoFormStyles.Submit} {
      justify-content: flex-end;
    }
  }
`;
const EmbeddedFormStyles = {
    Container,
    ContentWrapper,
    Title,
    Content,
    FormWrapper,
    ContentInner,
};
export default EmbeddedFormStyles;
